import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { ProductionAndSalesDetail } from "../../../components/Pages/Documents/ProductionAndSales/ProductionAndSalesDetail";
import ProductionAndSalesList from "../../../components/Pages/Documents/ProductionAndSales/ProductionAndSalesList";
import { NFLookupProductionAndSales } from "../../../components/Shared/NewForms/NFLookupProductionAndSales";
import { ReceiptFromProductionAndSalesService } from "../../../services/documents/ProductionAndSalesService";
import { CreateProductionAndSalesDto } from "../../../dtos/documents/ProductionAndSales/CreateProductionAndSalesDto";

export const ProductionAndSales: IAppEntity = {
  entityType: "document",
  title: "Production And Sales",
  pluralTitle: "Production And Sales",
  apiUrl: "ReceiptFromProductionAndSales",
  apiEnum: ReferenceTypes.DocumentReceiptFromProductionAndSale,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ProductionAndSalesDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ProductionAndSalesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupProductionAndSales, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new ReceiptFromProductionAndSalesService("ReceiptFromProductionAndSales"),
  getEmptyModel: () => {
    const model: CreateProductionAndSalesDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
      otherCosts:[],
      products:[],
      salary:[],
      materials:[],
      performedWorks:[],
      employeeEarnings:[],
      byProducts:[],
      downPayments:[],
      items:[]
    };
    return model;
  },
};
